module.exports = __webpack_public_path__ + "a6befbfc05719c06.ico";